import https from "@/lib/https";
import type {
  AwardDetail,
  AwardPayload,
  GetAwardListParams,
} from "@/interface/award";
import type { ApiResponse } from "@/interface/common";

const BASE_URL = "/api/awards/";

export const getAwardList = async (
  params?: GetAwardListParams,
): Promise<ApiResponse<AwardDetail[]>> => {
  return await https.get<ApiResponse<AwardDetail[]>>(BASE_URL, params);
};

export const getAwardById = async (
  id: number | string,
): Promise<ApiResponse<AwardDetail>> => {
  return await https.get<ApiResponse<AwardDetail>>(`${BASE_URL}${id}/`);
};

export const createAward = async (
  payload: AwardPayload,
): Promise<ApiResponse<AwardDetail>> => {
  return await https.post<ApiResponse<AwardDetail>>(BASE_URL, payload);
};

export const updateAward = async (
  id: number | string,
  payload: AwardPayload,
): Promise<ApiResponse<AwardDetail>> => {
  return await https.put<ApiResponse<AwardDetail>>(
    `${BASE_URL}${id}/`,
    payload,
  );
};

export const patchAward = async (
  id: number | string,
  payload: Partial<AwardPayload>,
): Promise<ApiResponse<AwardDetail>> => {
  return await https.patch<ApiResponse<AwardDetail>>(
    `${BASE_URL}${id}/`,
    payload,
  );
};

export const deleteAward = async (
  id: number | string,
): Promise<ApiResponse<void>> => {
  return await https.delete<ApiResponse<void>>(`${BASE_URL}${id}/`);
};
